import * as React from "react";
import styled from "@emotion/styled";
import { useFeatureFlagsWithOverrides } from "@src/utils/useFeatureFlag";
import { ExternalSwitches } from "@src/utils/experiments/constants";
import { DevToolsSettings } from "@src/components/devTools/devToolsSettings";

const BannerContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: #f9523e;
  color: white;
  padding: 12px 20px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  font-family: "Dojo Text", sans-serif;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  pointer-events: none;
`;

export const SparksTestModeBanner: React.FC = () => {
  // This hook properly subscribes to override changes from DevTools
  const { featureSwitchOverrides } = DevToolsSettings.useFeatureSwitchOverrides();
  const featureFlags = useFeatureFlagsWithOverrides();

  const flagValue = featureFlags?.[ExternalSwitches.WEB_JOURNEY_SPARKS_TEST_MODAL];

  if (flagValue !== "on") {
    return null;
  }

  return <BannerContainer>⚠️ Sparks Test Mode </BannerContainer>;
};
